/** @file treeUiOps: the tree-owned actions a node menu calls (rename, view-only hide). */
import { treeUi } from '../../panels/tree/treeUi';
import type { EditorStore } from '../../state/editorTypes';
import type { NodeViewOps } from './registryTypes';

/**
 * The node tree keeps rename and view-hidden state in its own store (`panels/tree/treeUi.ts`, T-316): the menu's
 * Rename starts the inline rename, Hide / Show toggle the view-only set (never `node.hidden`). State is read at call
 * time, so a menu built before a toggle still sees the current set.
 */
export function treeUiOps(store: EditorStore): NodeViewOps | undefined {
  const ui = treeUi(store);
  return {
    rename: (name) => { ui.getState().startRename(name); },
    isViewHidden: (name) => ui.getState().viewHidden.has(name),
    toggleViewHidden: (name) => { ui.getState().toggleViewHidden(name); },
  };
}
